// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-completed-after-deadline-badge .red-dot {
  width: 6px;
  height: 6px;
  background: linear-gradient(180deg, #ff6454 0%, #de3730 100%);
  border-radius: 50%;
}

.fi-completed-after-deadline-tooltip {
  max-width: 220px !important;
}
.fi-completed-after-deadline-tooltip.tooltip.fi-info-icon-tooltip.fi-task-v2-assignee-tooltip .content-wrapper .mat-icon {
  width: 18px;
  height: 18px;
  line-height: 18px;
}`, "",{"version":3,"sources":["webpack://./Source/app/task-v2/fi-task-v2-report/fi-task-v2-report-widget-details/completed-after-deadline-badge/completed-after-deadline-badge.component.scss"],"names":[],"mappings":"AACI;EACI,UAAA;EACA,WAAA;EACA,6DAAA;EACA,kBAAA;AAAR;;AAIA;EACI,2BAAA;AADJ;AAIQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAFZ","sourcesContent":[".fi-completed-after-deadline-badge {\r\n    .red-dot {\r\n        width: 6px;\r\n        height: 6px;\r\n        background: linear-gradient(180deg, #ff6454 0%, #de3730 100%);\r\n        border-radius: 50%;\r\n    }\r\n}\r\n\r\n.fi-completed-after-deadline-tooltip {\r\n    max-width: 220px !important;\r\n\r\n    &.tooltip.fi-info-icon-tooltip.fi-task-v2-assignee-tooltip .content-wrapper {\r\n        .mat-icon {\r\n            width: 18px;\r\n            height: 18px;\r\n            line-height: 18px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
